/* eslint-disable import/prefer-default-export */
export const getImageResizingTreatment = (state) => state?.flags?.treatments?.sl_web_image_resizing;
